<template>
    <div>
        <div v-if="loading || !data" class="text-center text-muted" style="padding:100px; font-style:italic">
            {{translate('loading')}}
        </div>
        <div class="row" v-else-if="hasAuth('Admin')">
            <div class="col"> <!-- Dönem -->
                <div class="roundbox">
                    <div class="rbcontent rbcontent-fixheight">
                        <h4>{{translate('summary.period')}}</h4>
                        <p>
                            <code>{{data.AccountCode}}</code> {{data.AccountTitle}}
                        </p>
                        <table class="table table-sm table-borderless ozet">
                            <tr>
                                <td>{{translate('summary.startDate')}}</td>
                                <td>:</td>
                                <td class="text-right">{{data.Period.StartDate | date}}</td>
                            </tr>
                            <tr>
                                <td>{{translate('summary.endDate')}}</td>
                                <td>:</td>
                                <td class="text-right">{{data.Period.EndDate | date}}</td>
                            </tr>
                        </table>
                        <div :class="{ 'text-info':!isLastMonth && !licenceRemainingDuration.isNegative, 'alert alert-warning': isLastMonth, 'alert alert-danger': licenceRemainingDuration.isNegative }">
                            <icon-exclamation-triangle v-if="isLastMonth || licenceRemainingDuration.isNegative" viewBox="0 0 16 16" width="24" height="24" style="margin-right:8px;" />
                            {{translate('summary.yourLicence')}}
                            <template v-if="licenceRemainingDuration.year">{{licenceRemainingDuration.year}} {{translate('summary.year')}} </template>
                            <template v-if="licenceRemainingDuration.month">{{licenceRemainingDuration.month}} {{translate('summary.month')}} </template>
                            <template v-if="licenceRemainingDuration.day">{{licenceRemainingDuration.day}} {{translate('summary.day')}} </template>

                            <template v-if="licenceRemainingDuration.isNegative">{{translate('summary.ended')}}</template>
                            <template v-else>{{translate('summary.willEnd')}}</template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col"> <!-- Modüller -->
                <div class="roundbox">
                    <div class="rbcontent rbcontent-fixheight">
                        <h4>{{translate('summary.modules')}}</h4>
                        <div>
                            <table class="ozet">
                                <tr>
                                    <td style="width:20px;" v-html="$options.filters.checkicon(hasModule('REM'))"></td>
                                    <td>{{translate('job.sendKep')}} <small class="text-muted">— {{translate('summary.sendKEPText')}}</small></td>
                                </tr>
                                <tr>
                                    <td style="width:20px;" v-html="$options.filters.checkicon(hasModule('REMManagement'))"></td>
                                    <td>{{translate('summary.remManagementSystem')}} <small class="text-muted">— {{translate('summary.remManagementText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('EYP'))"></td>
                                    <td>{{translate('summary.eyp')}} <small class="text-muted">— {{translate('summary.eypText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('FTP'))"></td>
                                    <td>FTP <small class="text-muted">— File Transfer Protocol</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('SFTP'))"></td>
                                    <td>s/FTP <small class="text-muted">— Secure File Transfer Protocol</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('API'))"></td>
                                    <td>API <small class="text-muted">— {{translate('summary.apiIntegration')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('UETS'))"></td>
                                    <td>{{translate('summary.uets')}} <small class="text-muted">— {{translate('summary.uetsText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('CAdES'))"></td>
                                    <td>CAdES <small class="text-muted">— {{translate('summary.cadesText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('PAdES'))"></td>
                                    <td>PAdES <small class="text-muted">— {{translate('summary.padesText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('ExternalSigner'))"></td>
                                    <td>{{translate('summary.externalSigner')}} <small class="text-muted">— {{translate('summary.externalSignerText')}}</small></td>
                                </tr>
                                <tr>
                                    <td v-html="$options.filters.checkicon(hasModule('IncomingDocManagement'))"></td>
                                    <td>{{translate('summary.incomingDoc')}} <small class="text-muted">— {{translate('summary.incomingDocText')}}</small></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100" style="height:20px;"></div>
            <div class="col"> <!-- Depolama -->
                <div class="roundbox">
                    <div class="rbcontent rbcontent-fixheight">
                        <h4>{{translate('summary.storage')}}</h4>
                        <div>
                            <div class="progress">
                                <div :title="translate('summary.percentageUsed:' + storagePercent)" class="progress-bar bg-success" role="progressbar" :style="{ width: storagePercent + '%' }" :aria-valuenow="storagePercent" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div style="padding-top:20px;">
                                <table class="table table-sm table-borderless ozet">
                                    <tbody>
                                        <tr>
                                            <td style="width:10px">{{translate('draft.sum')}}</td>
                                            <td>:</td>
                                            <td class="text-right">{{data.Period.StorageLimit | prettyBytes}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('summary.used')}}</td>
                                            <td>:</td>
                                            <td class="text-right">{{data.Period.UsedStorage | prettyBytes}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('summary.empty')}}</td>
                                            <td>:</td>
                                            <td class="text-right">{{data.Period.StorageLimit - data.Period.UsedStorage | prettyBytes}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot v-if="storagePercent > 90">
                                        <tr>
                                            <td colspan="3">
                                                <div class="text-warning">
                                                    {{translate('summary.storageAlmostFull')}}
                                                </div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col"> <!-- İmza -->
                <div class="roundbox">
                    <div class="rbcontent rbcontent-fixheight">
                        <h4>{{translate('summary.signature')}}</h4>
                        <table class="table table-sm table-borderless ozet">
                            <tbody>
                                <!-- <tr>
                                    <td style="width:10px;">İmza&nbsp;Limiti</td>
                                    <td>:</td>
                                    <td class="text-right">{{data.Period.SignatureLimit}}</td>
                                </tr> -->
                                <tr>
                                    <td v-html="translate('summary.signedSignature')"></td>
                                    <td>:</td>
                                    <td class="text-right">{{data.Period.UsedSignature}}</td>
                                </tr>
                                <!-- <tr>
                                    <td>Kalan&nbsp;İmza</td>
                                    <td>:</td>
                                    <td class="text-right">{{data.Period.SignatureLimit - data.Period.UsedSignature}}</td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col"> <!-- Kullanıcı -->
                <div class="roundbox">
                    <div class="rbcontent rbcontent-fixheight">
                        <h4>{{translate('summary.user')}}</h4>
                        <div>
                            <table class="table table-sm table-borderless ozet">
                                <tbody>
                                    <tr>
                                        <td style="width:10px;" v-html="translate('summary.userLimit')"></td>
                                        <td>:</td>
                                        <td class="text-right">{{data.Period.UserLimit}}</td>
                                    </tr>
                                    <tr>
                                        <td v-html="translate('summary.totalUser')"></td>
                                        <td>:</td>
                                        <td class="text-right">{{data.Period.TotalUser}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('summary.activeUser')}}</td>
                                        <td>:</td>
                                        <td class="text-right">{{data.Period.ActiveUser}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('summary.passiveUser')}}</td>
                                        <td>:</td>
                                        <td class="text-right">{{data.Period.TotalUser - data.Period.ActiveUser}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('summary.emptySlot')}}</td>
                                        <td>:</td>
                                        <td class="text-right">{{data.Period.AvailableUser}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import iconExclamationTriangle from '../components/Icons/exclamation-triangle.svg'
export default {
    components: {
         iconExclamationTriangle
    },
    data(){
        return {
            loading: false,
            data: null
        };
    },
    created(){
        axios.get("/summary/get")
        .then(x => {
            console.log('Summary Result:', x);
            this.data = x.data;
        })
    },
    computed: {
        storagePercent(){
            if(!this.data || !this.data.Period)
                return 0;
            return parseInt(Math.min(this.data.Period.UsedStorage / this.data.Period.StorageLimit, 1.0) * 100, 10);
        },
        licenceRemainingDuration(){ // Lisansın bitmesine kalan süre
            var endDate = new Date(this.data.Period.EndDate);
            return new Date().diff(endDate);
        },
        isLastMonth(){
            var diff = this.licenceRemainingDuration;
            return diff.year == 0 && diff.month == 0 && diff.day > 0;
        }
    }
}
</script>
<style scoped>
    .rbcontent-fixheight {
        min-height:290px;
    }
</style>